import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumImageFormat implements BaseEnumType {
  private static allValues: EnumImageFormat[] = []; // make sure this is top-most
  
  public static png = new EnumImageFormat(0, "Png", "enum_image_format_png");
  public static jpeg = new EnumImageFormat(1, "Jpeg", "enum_image_format_jpeg");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumImageFormat.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isPng() { return this === EnumImageFormat.png; }
  public isJpeg() { return this === EnumImageFormat.jpeg; }

  public static getValues(): readonly EnumImageFormat[] {
    return EnumImageFormat.allValues;
  }

  public static getValuesExcept0(): readonly EnumImageFormat[] {
    return EnumImageFormat.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumImageFormat {
    const found = EnumImageFormat.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumImageFormat - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumImageFormat): EnumImageFormat {
    const found = name ? EnumImageFormat.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumImageFormat - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumImageFormat>): boolean {
    return this.key === other?.key;
  }
}